import colors from '../_shared/colors';

export default {
  container: `
    position: fixed;
    inset: 0;
    background: #fff;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    padding: 8vh 0 4vh;
    box-sizing: border-box;
  `,
  title: `
    color: ${colors.highlight};
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0;
    text-align: center;
  `,
  brandDiv: `
    margin: 60px 0;
  `,
  brandImage: `
    width: 100%;
    height: 100%;
  `,
};
